import { get } from 'api/api';

import type { GetDashboardsResponseDTO, GetEmbedUrlResponseDTO } from '../declarations/reporting';

export const getDashboardIds = async (): Promise<GetDashboardsResponseDTO> => {
  const response = await get<GetDashboardsResponseDTO>('/quicksight-dashboards/dashboards');
  return response.data;
};

export const getEmbedUrl = async (dashboardId: string): Promise<GetEmbedUrlResponseDTO> => {
  const response = await get<GetEmbedUrlResponseDTO>(
    `/quicksight-dashboards/dashboards/${dashboardId}`
  );
  return response.data;
};
